import { StripeIdealBankElementOptions } from "@stripe/stripe-js";
import { grey } from "@material-ui/core/colors";
import { useTheme } from "@material-ui/core";

const baseProps = {
  fontSize: "16px",
  lineHeight: "19px",
  padding: "14px",
  letterSpacing: "0.15px",
  fontWeight: 400,
  iconColor: grey[500],
} as const;

export const useIdealOptions = (): StripeIdealBankElementOptions => {
  const theme = useTheme();
  return {
    iconStyle: "solid",
    style: {
      base: {
        ...baseProps,
        color: theme.palette.contrastText.main,
        backgroundColor: theme.palette.otherElementsBackground.main,
      },
      complete: {
        ...baseProps,
        color: theme.palette.contrastText.main,
        backgroundColor: theme.palette.otherElementsBackground.main,
      },
    },
  };
};
